import Vue from "vue";
import Vuetify from "vuetify/lib/framework";

Vue.use(Vuetify);

/**
 * Pet Walkies admin theme.
 * One confident brand blue, a teal accent and a calm neutral canvas.
 * Everything else (radius, shadows, typography) lives in the global
 * design-system styles in App.vue.
 */
export default new Vuetify({
  theme: {
    options: {
      customProperties: true,
    },
    themes: {
      light: {
        primary: "#1F4FA3",
        secondary: "#0E9F9F",
        accent: "#F59E0B",
        info: "#2E90FA",
        success: "#12B76A",
        warning: "#F79009",
        error: "#F04438",
        anchor: "#1F4FA3",
      },
    },
  },
});
